import $ from "jquery";
import { debounce } from "../utils/functions";
import apiFetch from "@wordpress/api-fetch";
import { reloadScriptPostCard } from "./post-card";
import {
  reloadScriptActions,
  reloadScriptCommentEdit,
} from "./comment-actions";
import { reloadScriptComment } from "./comment";
import { reloadScriptPostLikeButton } from "./post-like-button";
import { reloadScriptPostActions } from "./post-actions";

const $window = $(window);

const company = (element, index) => {
  $window.off(`resize:width.company${index}`);
  $window.on(
    `resize:width.company${index}`,
    debounce(() => uniteLabels(element))
  );

  $(() => {
    uniteLabels(element);
  });

  const companyPosts = element.find(".company__posts");
  
  const filter = {
    type: "basic",
    companyId: element.data('companyId'),
    page: 1,
    limit: 10,
  };

  const currentType = 'basic';

  bindTabSwitcher(element, filter, currentType);
  bindScroll(companyPosts.get(0), filter);
};

const uniteLabels = (element) => {
  const $attributes = element.find(".company__attributes");
  const $labels = $attributes.find(".company__attribute label");

  if (!$attributes.length || !$labels.length) return;

  $labels.css("width", "");

  let desiredWidth = 0;

  $labels.each(function () {
    const $thisWidth = $(this).width();

    if ($thisWidth > desiredWidth) {
      desiredWidth = $thisWidth;
    }
  });

  $labels.css("width", `${desiredWidth}px`);
};

const bindTabSwitcher = (element, filter, currentType) => {
  const $tabSwitcher = element.find(".company__tab-switcher");

  $tabSwitcher.off("click");
  $tabSwitcher.on("click", function () {
    // const $thisEl = $(this);
    
    // const tab = $thisEl.data('tab');
    
    // if (tab == 0 || tab == 1) {
    //   filter.type = $thisEl.data("type");
    //   filter.page = 1;
    //   reRenderPosts(element.get(0), filter);
    // }

    // const $activeButton = element.find(".company__tab-switcher--active");

    // if (!$thisEl.is($activeButton)) {
    //   $activeButton.removeClass("company__tab-switcher--active");
      
    //   element
    //     .find(`.company__tab-switcher[data-tab="${$thisEl.data("tab")}"]`)
    //     .addClass("company__tab-switcher--active");
    // }
    const $thisEl = $(this);
    const $activeButton = element.find(".company__tab-switcher--active");

    const type = $thisEl.data("type");
    const validTypes = ['basic', 'tokenholders'];
    
    if (validTypes.includes(type)) {
      filter.type = type;
      filter.page = 1;
      reRenderPosts(element.get(0), filter);
    }

    if (!$thisEl.is($activeButton)) {
      $activeButton.removeClass("company__tab-switcher--active");

      element
        .find(`.company__tab-switcher[data-tab="${$thisEl.data("tab")}"]`)
        .addClass("company__tab-switcher--active");

      if (type === undefined 
          || (validTypes.includes(currentType) && !validTypes.includes(type)) 
          || (!validTypes.includes(currentType) && validTypes.includes(type))) {
        const $activeTab = element.find(".company__tab--active");
        const $nextActiveTab = element.find(
          '.company__tab[data-tab="' + $thisEl.data("tab") + '"]'
        );

        $activeTab
          .removeClass("company__tab--active")
          .one("transitionend", () =>
            $activeTab.hide(0, () =>
              $nextActiveTab.show(0, () =>
                $nextActiveTab.addClass("company__tab--active")
              )
            )
          );
      }
    }
    currentType = type;
  });
};

const bindScroll = (el, filter) => {
  const options = {
    root: document.querySelector(".page__body"),
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        filter.page += 1;
        appendPosts(el, filter);
      }
    });
  };
  
  const observer = new IntersectionObserver(callback, options);
  const lazyElems = el.querySelectorAll(".posts-lazy");

  if (lazyElems.length) {
    observer.observe(...lazyElems);
  }
};

const reRenderPosts = async (el, filter) => {
  const $el = $(el);
  const loader = $el.find(".company__loader");
  const content = $el.find("#company-content");

  loader.show();
  content.html("");

  try {
    const newPosts = await getPosts(filter);
    console.log(content);
    loader.hide();
    
    content.html(newPosts.html);
    reloadScriptPostCard();
    reloadScriptComment();
    reloadScriptActions();
    reloadScriptCommentEdit();
    reloadScriptPostLikeButton();
    reloadScriptPostActions();

    if (newPosts?.count) {
      bindScroll(el, filter);
    }
  } catch (e) {
    console.error(e);
  }
};

const appendPosts = async (el, filter) => {
  const $el = $(el);
  const content = $el.find("#company-content");

  try {
    const newPosts = await getPosts(filter);
    console.log(newPosts);
    content.find(".posts-lazy").remove();

    content.append(newPosts.html);
    reloadScriptPostCard();
    reloadScriptComment();
    reloadScriptActions();
    reloadScriptCommentEdit();
    reloadScriptPostLikeButton();
    reloadScriptPostActions();

    if (newPosts?.count) {
      bindScroll(el, filter);
    }
  } catch (e) {
    console.error(e);
  }
};

const getPosts = async (filter) => {
  return await apiFetch({
    path: "/xixoio/v1/post-insight/html",
    method: "POST",
    data: filter,
  });
};

export const reloadScriptCompany = () => {
  const $company = $(".company");

  $company.each(function (index) {
    company($(this), index);
  });
};
reloadScriptCompany();
